import { render, staticRenderFns } from "./WShippingZones.vue?vue&type=template&id=83593afa&scoped=true&"
import script from "./WShippingZones.vue?vue&type=script&lang=js&"
export * from "./WShippingZones.vue?vue&type=script&lang=js&"
import style0 from "./WShippingZones.vue?vue&type=style&index=0&id=83593afa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83593afa",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WSwitch from '@/components/WSwitch.vue'
autoInstallComponents(component, {WSwitch})
